<template>
  <div class="download-page custom-scrollbar">

    <div v-if="isloading" class="fullscreen-loader">
      <fulfilling-bouncing-circle-spinner :animation-duration="1000" :size="60" color="#ff1d5e" />
    </div>

    <div class="content-wrapper" v-show="!isloading">
      <header class="header">
        <img class="logo" src="/logo.png" alt="">
        <h1 class="title">YW LOG ZAP</h1>
        <p class="subtitle">YW日志飞刃</p>
      </header>

      <div class="intro-card">
        <!-- <h2 class="intro-title">简介</h2> -->
        <div class="intro-text">
          <p style="margin-bottom: 15px">
            这是一款专为客户端开发者打造的便捷工具，提供清晰直观的用户日志查看体验。
          </p>
          <div style="padding-left: 20px">
            <div style="display: flex; align-items: center; margin-bottom: 8px">
              <div style="width: 8px; height: 8px; border-radius: 50%; background: #409EFF; margin-right: 12px"></div>
              <span>VSCode一键打开用户日志（需启用VSCode code功能，Windows系统请将code.exe添加至环境变量）</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px">
              <div style="width: 8px; height: 8px; border-radius: 50%; background: #409EFF; margin-right: 12px"></div>
              <span>便捷的用户反馈日志查阅功能</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px">
              <div style="width: 8px; height: 8px; border-radius: 50%; background: #409EFF; margin-right: 12px"></div>
              <span>实用的时间戳转换工具</span>
            </div>
          </div>
          <p style="margin-top: 15px; font-style: italic; color: #67C23A">
            更多实用功能持续开发中，敬请期待！
          </p>
          <div
            style="margin-top: 15px; padding: 12px 16px; background-color: #2D2D2D; border-radius: 4px; border-left: 5px solid #666666; color: #E0E0E0;">
            <span style="color: #FFFFFF; font-weight: bold;">Mac用户注意：</span>
            <span>如果安装时提示"已损坏"，请在终端输入以下命令：</span>
            <div style="position: relative; margin-top: 8px;">
              <code
                style="display: block; padding: 8px; background: #1A1A1A; border-radius: 4px; color: #00E676; font-family: monospace;">
        sudo xattr -r -d com.apple.quarantine /Applications/YW\ Log\ Zap.app
      </code>
              <button @click="copyToClipboard('sudo xattr -r -d com.apple.quarantine /Applications/YW\\ Log\\ Zap.app')"
                style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); 
               padding: 4px 8px; 
               background: #404040; 
               border: none; 
               border-radius: 4px; 
               color: #FFFFFF;
               cursor: pointer;
               font-size: 12px;" onmouseover="this.style.background='#505050'"
                onmouseout="this.style.background='#404040'">
                复制
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="download-grid">
        <div v-for="(download, index) in downloads" :key="index" class="download-card">
          <h3 class="download-title">
            <component :is="download.icon" class="icon" />
            {{ download.title }}
          </h3>
          <button class="download-button" @click="open_url(download.version)">
            <download-icon class="icon" />
            下载 {{ download.title }} 版本
          </button>
        </div>
      </div>
    </div>

    <footer>
      <p> YW LOG ZAP &copy; {{ currentYear }} By Doone. 保留所有权利。</p>
    </footer>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
import { Laptop, Apple, Download as DownloadIcon } from 'lucide-vue-next'
import axios from 'axios';
import { ElMessage } from 'element-plus'

const download_url_map = ref({
  'windows': '',
  'macos-x86': '',
  'macos-m1': '',
})

const currentYear = computed(() => new Date().getFullYear())
const isloading = ref(true);

const downloads = ref([
  { title: 'Windows', icon: Laptop, version: 'windows' },
  { title: 'macOS Intel芯片', icon: Apple, version: 'macos-x86' },
  { title: 'macOS M芯片', icon: Apple, version: 'macos-m1' }
])

onMounted(async () => {
  try {
    const response = await axios.get('https://api.internal.52yuwan.com/yw_log_zap/release');
    console.log(response.data);
    const { code, mac_aarch, mac_x64, win } = response.data;
    if (code === 200) {
      download_url_map.value['windows'] = win;
      download_url_map.value['macos-x86'] = mac_x64;
      download_url_map.value['macos-m1'] = mac_aarch;
      isloading.value = false;
    }
  } catch (error) {
    console.error('获取release失败:', error);
  }
});

const open_url = (version) => {
  window.open(download_url_map.value[version], '_blank');
}

function copyToClipboard(text) {
  navigator.clipboard.writeText(text).then(() => {
    // 可以添加提示复制成功的逻辑
    ElMessage({
      message: '复制成功！',
      type: 'success',
      duration: 2000
    })
  }).catch(err => {
    console.error('复制失败:', err);
    ElMessage({
      message: '复制失败，请手动复制',
      type: 'error',
      duration: 2000
    })
  });
}
</script>

<style scoped>
/* 添加以下全局样式 */
:root {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background: linear-gradient(to bottom right, #1a202c, #4a1d96, #1e3a8a);
}

.download-page {
  min-height: 100vh;
  background: linear-gradient(to bottom right, #1a202c, #4a1d96, #1e3a8a);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  overflow: hidden;
}

.content-wrapper {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  gap: 2rem;
}

.header {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.logo {
  width: 18%;
  height: 18%;
}

.logo-container {
  display: inline-block;
  padding: 0.5rem;
  background-color: #3b82f6;
  border-radius: 9999px;
}

.title {
  font-size: 3rem;
  font-weight: bold;
  color: white;
}

.subtitle {
  font-size: 1.25rem;
  color: #d1d5db;
}

.intro-card {
  background-color: #1f2937;
  border-color: #374151;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.intro-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #f3f4f6;
  margin-bottom: 1rem;
}

.intro-text {
  color: #d1d5db;
  text-align: center;
}

.download-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.5rem;
  margin-bottom: 30%;
}

@media (min-width: 768px) {
  .download-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.download-card {
  background-color: #1f2937;
  border-color: #374151;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.download-title {
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  font-weight: 600;
  color: #f3f4f6;
  margin-bottom: 1rem;
}

.icon {
  margin-right: 0.5rem;
  height: 1.25rem;
  width: 1.25rem;
}

.download-button {
  width: 100%;
  background-color: #2563eb;
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  text-decoration: none;
}

.download-button:hover {
  background-color: #1d4ed8;
}

.download-button .icon {
  margin-right: 0.5rem;
  height: 1rem;
  width: 1rem;
}

footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  background-color: #2d3748;
  padding: 1rem;
  text-align: center;
  color: #a0aec0;
}
</style>